export default class ReadingHistoryActions {
    constructor(bus) {
        this.bus = bus;

        this.bus.on('title:history:fail', (...params) =>
            this.historyFailure(...params)
        );
    }

    historyFailure({ titleModel }, jqXHR, textStatus, errorThrown) {
        let response = JSON.parse(jqXHR.responseText || '{}');

        if (response.sessionExpired) {
            this.bus.trigger('user:session:expired');
        } else if (toaster) {
            toaster.push(window.html('error.defaultErrorHtml'), 'error');
        }
    }
}
